"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentAttributes = void 0;
const componentAttributes_1 = __importDefault(require("./componentAttributes"));
exports.componentAttributes = componentAttributes_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvdXRpbHMvZHluYW1pY0NvbnRleHQvZW50aXRpZXMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsZ0ZBQXdEO0FBRS9DLDhCQUZGLDZCQUFtQixDQUVFIn0=


// WEBPACK FOOTER //
// ../../../../../src/utils/dynamicContext/entities/index.ts